export default __webpack_public_path__ + "static/media/p3.9a8b7b80.jpg";